// const AMEX_API_URL = 'https://172.20.19.10:9333/';
// const AMEX_TOKEN_URL = 'https://172.20.19.10:9333/';

const AMEX_API_URL = 'https://online.americanexpress.com.sa/';
// const AMEX_TOKEN_URL = 'https://api-encryption.xema.site/';

const AGREEMENT_LINKS = {
    en: 'https://www.americanexpress.com.sa/sites/default/files/2026-09/9.1_amex_cent_cm_agreement_aug_2026_v2_eng.pdf',
    ar: 'https://www.americanexpress.com.sa/sites/default/files/2026-09/9.1_amex_cent_cm_agreement_aug_2026_v2_arb.pdf'
};

export default {
    AMEX_API_URL,
    AGREEMENT_LINKS
    // AMEX_TOKEN_URL
}
